/* tslint:disable */
/* eslint-disable */
/**
 * MG-DX Pharmacy API
 * API for Pharmacy
 *
 * The version of the OpenAPI document: 0.2.0
 * Contact: developers@mg-dx.co.jp
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { tzDate } from "@mgdx-libs/dayjs";
import { exists, mapValues } from "../runtime";

export const PharmacySatudoraECOperatorListItemTypename = "PharmacySatudoraECOperatorListItem" as const;

/**
 *
 * @export
 * @interface PharmacySatudoraECOperatorListItem
 */
export interface PharmacySatudoraECOperatorListItem {
  /**
   *
   * @type {string}
   * @memberof PharmacySatudoraECOperatorListItem
   */
  authId: string;
  /**
   *
   * @type {number}
   * @memberof PharmacySatudoraECOperatorListItem
   */
  id: number;
  /**
   *
   * @type {number}
   * @memberof PharmacySatudoraECOperatorListItem
   */
  pharmacyId: number;
  /**
   * Resource type name
   * @type {string}
   * @memberof PharmacySatudoraECOperatorListItem
   */
  readonly __typename?: string;
}

export function PharmacySatudoraECOperatorListItemFromJSON(json: any): PharmacySatudoraECOperatorListItem {
  return PharmacySatudoraECOperatorListItemFromJSONTyped(json, false);
}

export function PharmacySatudoraECOperatorListItemFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean
): PharmacySatudoraECOperatorListItem {
  if (json === undefined || json === null) {
    return json;
  }
  return {
    __typename: PharmacySatudoraECOperatorListItemTypename,

    authId: json["auth_id"],
    id: json["id"],
    pharmacyId: json["pharmacy_id"],
  };
}

export function PharmacySatudoraECOperatorListItemToJSON(object?: PharmacySatudoraECOperatorListItem | null): any {
  if (object === undefined) {
    return undefined;
  }
  if (object === null) {
    return null;
  }
  const { __typename, ...value } = object;
  return {
    auth_id: value.authId,
    id: value.id,
    pharmacy_id: value.pharmacyId,
  };
}
